"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchByValue = void 0;
var apps_shared_1 = require("@l2p/apps-shared");
var game_api_1 = require("@l2p/game-api");
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = require("react");
var SEARCH_TITLE = 'search_title';
var IS_SEARCH_ACTIVE = 'is_search_active';
var GAMES_SEARCH_RESULT = 'games_search_results';
var MIN_SEARCH_LENGTH = 0;
var useSearchByValue = function (provider) {
    var _a;
    var minSearchLength = (0, react_1.useMemo)(function () { return MIN_SEARCH_LENGTH; }, []);
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var _b = (0, swr_hooks_1.useCache)(), getDataFromCache = _b.getDataFromCache, setDataToCache = _b.setDataToCache;
    var _c = (0, react_1.useState)(getDataFromCache(SEARCH_TITLE) || ''), searchValue = _c[0], setSearchValue = _c[1];
    var _d = (0, react_1.useState)(getDataFromCache(IS_SEARCH_ACTIVE) || false), isSearchActive = _d[0], setSearchActive = _d[1];
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var prevSearch = (0, react_1.useRef)(searchValue);
    var prevProviderId = (0, react_1.useRef)(provider === null || provider === void 0 ? void 0 : provider.id);
    var prevCurrency = (0, react_1.useRef)(currentCurrency);
    var searchTimer = (0, react_1.useRef)(null);
    var _e = (0, swr_hooks_1.useSearchGames)({
        successAction: function (results) {
            setDataToCache(GAMES_SEARCH_RESULT, results);
        },
    }), searchGames = _e.searchGames, data = _e.data, isSubmitting = _e.isSubmitting;
    var geoData = (0, swr_hooks_1.useGeo)().data;
    (0, react_1.useEffect)(function () {
        if (Object.keys(breakpoints).length === 0 ||
            !searchValue ||
            searchValue === '' ||
            searchValue.length < minSearchLength ||
            (prevSearch.current === searchValue &&
                prevProviderId.current === (provider === null || provider === void 0 ? void 0 : provider.id) &&
                currentCurrency === currentCurrency))
            return;
        searchTimer.current = setTimeout(function () {
            var _a, _b;
            searchGames({
                page: 0,
                limit: 1000,
                filter: {
                    devices: [
                        breakpoints.mobile || breakpoints.tablet
                            ? game_api_1.GameDeviceTypeEnum.Mobile
                            : game_api_1.GameDeviceTypeEnum.Desktop,
                        game_api_1.GameDeviceTypeEnum.Universal,
                    ],
                    title: searchValue,
                    providers: (prevProviderId === null || prevProviderId === void 0 ? void 0 : prevProviderId.current)
                        ? [prevProviderId === null || prevProviderId === void 0 ? void 0 : prevProviderId.current]
                        : undefined,
                    allowedCountries: ((_a = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _a === void 0 ? void 0 : _a.countryCode)
                        ? [(_b = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _b === void 0 ? void 0 : _b.countryCode]
                        : undefined,
                    currencies: currentCurrency ? [currentCurrency] : undefined,
                },
            });
        }, 200);
        prevSearch.current = searchValue;
        prevProviderId.current = provider === null || provider === void 0 ? void 0 : provider.id;
        prevCurrency.current = currentCurrency;
        return function () {
            if (searchTimer.current)
                clearTimeout(searchTimer.current);
        };
        /*eslint-disable-next-line*/
    }, [
        breakpoints,
        (_a = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _a === void 0 ? void 0 : _a.countryCode,
        searchGames,
        searchValue,
        provider,
        currentCurrency,
    ]);
    var gamesToShow = (0, react_1.useMemo)(function () {
        var _a, _b, _c;
        if ((searchValue === '' || searchValue.length < minSearchLength) &&
            prevSearch.current)
            return [];
        return (((_b = (_a = getDataFromCache(GAMES_SEARCH_RESULT)) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.edges) ||
            ((_c = data === null || data === void 0 ? void 0 : data.data) === null || _c === void 0 ? void 0 : _c.edges) ||
            []);
    }, [searchValue, data, getDataFromCache, minSearchLength]);
    (0, react_1.useEffect)(function () {
        if (!isSearchActive && !isSubmitting) {
            setSearchActive(true);
            setDataToCache(IS_SEARCH_ACTIVE, true);
        }
    }, [isSearchActive, isSubmitting, setDataToCache]);
    var handleSearchInputClear = (0, react_1.useCallback)(function () {
        setSearchValue('');
        setDataToCache(SEARCH_TITLE, '');
    }, [setDataToCache]);
    var handleSearchInputChange = (0, react_1.useCallback)(function (event) {
        setSearchValue(event.currentTarget.value);
        setDataToCache(SEARCH_TITLE, event.currentTarget.value);
    }, [setDataToCache]);
    return {
        isSubmitting: isSubmitting,
        games: gamesToShow,
        searchValue: searchValue,
        isSearchActive: isSearchActive,
        handleSearchInputChange: handleSearchInputChange,
        handleSearchInputClear: handleSearchInputClear,
    };
};
exports.useSearchByValue = useSearchByValue;
exports.default = exports.useSearchByValue;
